import React from 'react'

const Activities = ({term, petitions, questions, submitters, proponents}) => {
  return (
    <div>
      <h3>任期: {term.from} 〜 {term.to}</h3>
      <table>
        <tbody>
         <tr>
            <th>議会での質問 {questions.length}件</th>
            <td>
              <ul>
                {questions.map((question, idx) => {
                  return <li key={idx}><a href={question.url} rel='noopener noreferrer' target='_blank'>{question.title}</a></li>;
                })}
              </ul>
            </td>
          </tr>
          <tr>
            <th>提出議案 {submitters.length}件</th>
            <td>
              <ul>
                {submitters.map((node, idx) => {
                console.log(node);
                  return <li key={idx}><a href={node.url} rel='noopener noreferrer' target='_blank'>{node.title}</a></li>;
                })}
              </ul>
            </td>
          </tr>
          <tr>
            <th>議員提出に賛同した議案 {proponents.length}件</th>
            <td>
              <ul>
               {proponents.map((node, idx) => {
                  return <li key={idx}><a href={node.url} rel='noopener noreferrer' target='_blank'>{node.title}</a></li>;
                })}
              </ul>
            </td>
          </tr>
          <tr>
            <th>紹介請願</th>
            <td>
              <ul>
                {petitions.map((node, idx) => {
                  return <li key={idx}><a href={node.url} rel='noopener noreferrer' target='_blank'>{node.title}</a></li>;
                })}
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Activities;